import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";

@Injectable({ providedIn: "root" })
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  /**
   * Navigates back in the history stack. If there are no more entries in the history,
   * it navigates to the specified fallback route or calls the fallback handler.
   * @param fallbackRoute The route to navigate to if there are no more entries in the history.
   * @param fallbackHandler A function to call if there are no more entries in the history and no fallback route is provided.
   */
  back(fallbackRoute?: string, fallbackHandler: () => void = null): void {
    // On retire de l'historique les urls qui renvoient vers l'accueil comme '/?returnUrl=...'
    this.history = this.history.filter(x => !x.startsWith("/?"));
    this.history.pop();

    if (this.history.length > 0) {
      this.location.back();
    }
    else if (fallbackRoute) {
      this.router.navigate([fallbackRoute]);
    } 
    else if (fallbackHandler) {
      fallbackHandler();
    }
    else {
      this.router.navigateByUrl("/");
    }
  }
}